import { blogSettings, commentList, htmlEditor } from '@modules/blog/blog.js'
import clickOutside from '../../utils/clickOutside.js'
import { translate } from '@modules/locale/locale.js'
import http from '../../utils/http.js'
import confirmDialog from '@utils/confirm.js'
import { slideTo } from '@utils/animation.js'
import confirm from '@utils/confirm.js'
import datepicker from '../../modules/datepicker/datepicker.js'
import { useDirtyStore } from '@store/dirty.js'

const blogElement = document.querySelector('.blog-profile')
const blogCode = blogElement.dataset.blogCode

/**
 * Make images inside the blogpost entry clickable and open with Photoswipe
 */
document.querySelectorAll('.body-text img').forEach((imgElement) => {
    // Wrap element around <a> and add .photoswipe
    const a = document.createElement('a')
    a.href = imgElement.src
    a.classList.add('photoswipe')
    a.appendChild(imgElement.cloneNode(true))
    imgElement.parentNode.replaceChild(a, imgElement)
})

htmlEditor('#bodyText', {
    images_upload_url: `/blog/${blogCode}/admin/upload/`,
})

htmlEditor('#about', {
    images_upload_url: `/blog/${blogCode}/admin/upload/`,
})

commentList('#comments')

let nav = document.querySelector('.blog-profile nav ul')

nav.querySelectorAll('.dropdown-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
        let target = document.querySelector(this.dataset.target)

        if (!target || !target.classList.contains('hidden')) {
            return
        }

        let rect = this.getBoundingClientRect()

        target.classList.remove('hidden')

        let w = target.offsetWidth
        let ww = window.innerWidth

        if (rect.right - Math.ceil(rect.width / 2) + Math.ceil(w / 2) > ww) {
            target.classList.add('right')
            target.classList.remove('center', 'left')

            target.style.left = 'auto'
            target.style.right = Math.max(0, ww - rect.right) + 'px'
            target.style.top = '0'
        } else if (rect.left + Math.ceil(rect.width / 2) - Math.ceil(w / 2) < 0) {
            target.classList.add('left')
            target.classList.remove('center', 'right')

            target.style.right = 'auto'
            target.style.left = Math.max(0, rect.left) + 'px'
            target.style.top = '0'
        } else {
            target.classList.add('center')
            target.classList.remove('right', 'left')

            target.style.right = 'auto'
            target.style.left = rect.left + Math.ceil(rect.width / 2) - Math.ceil(w / 2) + 'px'
            target.style.top = '0'
        }

        clickOutside(target, function () {
            target.classList.add('hidden')
        })
    })
})

// Submit event handler for the blog entry form
const blogEntryForm = document.getElementById('blog-entry-form')
blogEntryForm?.addEventListener('submit', function (e) {
    const dirtyStore = useDirtyStore()
    dirtyStore.setIsDirty(false)
    const submitButton = this.querySelector('.submit-button')
    if (submitButton.classList.contains('disabled')) {
        e.preventDefault()
        return false
    }
})

// Change event handler for input fields in the blog entry form
blogEntryForm?.querySelectorAll('input').forEach(function (input) {
    input.addEventListener('change', function () {
        const dirtyStore = useDirtyStore()
        dirtyStore.setIsDirty(true)
    })
})

// Click event handler for the "new category" button
const newCategoryButton = document.getElementById('new-category-button')
newCategoryButton?.addEventListener('click', function () {
    const input = document.getElementById('new-category-input')
    if (input.style.display !== 'none' && input.value) {
        newCategory(input.value)
        input.value = ''
        input.style.display = 'none'
    } else {
        input.style.display = 'inline'
        input.focus()
    }
})

// Keydown and blur event handlers for the "new category" input field
const newCategoryInput = document.getElementById('new-category-input')
newCategoryInput?.addEventListener('keydown', function (e) {
    if (e.which === 13) {
        e.preventDefault()
        newCategory(this.value)
        this.value = ''
        this.style.display = 'none'
    } else if (e.which === 27) {
        this.style.display = 'none'
    }
})
newCategoryInput?.addEventListener('blur', function () {
    if (!this.value) {
        this.style.display = 'none'
    }
})

// Click event handler for the "delete" button
const deleteButton = document.getElementById('delete-button')
deleteButton?.addEventListener('click', function (e) {
    e.preventDefault()
    confirm(null, translate('blog_admin_entry_delete_confirm')).then(() => {
        document.getElementById('delete-form').submit()
    })
})

// Function to create a new category
const newCategory = function (text) {
    if (!text) {
        return
    }

    const container = document.createElement('span')
    container.classList.add('flat-checkbox')

    const input = document.createElement('input')
    input.type = 'checkbox'
    input.name = 'newCategories[]'
    input.value = text.trim()
    input.checked = true
    const id = 'new-category-' + new Date().getTime()
    input.id = id

    const label = document.createElement('label')
    label.innerText = text
    label.setAttribute('for', id)

    container.appendChild(input)
    container.appendChild(label)

    document.getElementById('category-list').appendChild(container)
}

// Datepicker initialization
datepicker('#publishing-date', {
    dateFormat: 'yy-mm-dd',
})

// Change event handlers for the "published" and "scheduled" checkboxes
const publishedCheckbox = document.getElementById('published')
publishedCheckbox?.addEventListener('change', function () {
    const publishingOptions = document.getElementById('publishing-options')
    publishingOptions.classList.toggle('hidden', !this.checked)
})

const scheduledCheckbox = document.getElementById('scheduled')
scheduledCheckbox?.addEventListener('change', function () {
    const schedulingOptions = document.getElementById('scheduling-options')

    schedulingOptions.classList.toggle('hidden', !this.checked)

    schedulingOptions.querySelectorAll('input').forEach((input) => {
        input.disabled = !this.checked
    })
})

// Change event handler for the artwork file input
const artworkInput = document.getElementById('artwork')
artworkInput?.addEventListener('change', function () {
    const formData = new FormData()

    if (this.files) {
        for (let i = 0; i < this.files.length; i++) {
            formData.append(this.name, this.files[i])
        }
    } else {
        return false
    }

    http.post(`/blog/${blogCode}/admin/upload/`, formData)
        .then(({ data }) => {
            if (data.success === false) {
                throw new Error(data.message || 'Upload failed.')
            }

            document.getElementById('artwork-image').src = data.location
            document.getElementById('artworkUrl').value = data.location
            document.querySelector('#artwork-image').parentElement.classList.remove('hidden')
            document.getElementById('upload-artwork-container').classList.add('hidden')
        })
        .catch(function (error) {
            console.error(error)
        })
})

// Click event handler for the "remove artwork image" button
const removeArtworkImageButton = document.getElementById('remove-artwork-image')
removeArtworkImageButton?.addEventListener('click', async () => {
    if (await confirmDialog(null, null)) {
        document.getElementById('artwork-image').src = ''
        document.getElementById('artworkUrl').value = ''
        document.querySelector('#artwork-image').parentElement.classList.add('hidden')
        document.getElementById('upload-artwork-container').classList.remove('hidden')
    }
})

/**
 * Scroll to comment
 */
const params = new URLSearchParams(window.location.search)
const commentId = params.get('comment')
const reply = params.get('reply') === 'true'

if (commentId && reply === true) {
    const commentElement = document.querySelector('#comments .comment-' + commentId)
    commentElement.querySelector('.reply-button')?.click()
    slideTo('#comments .comment-form-container')
}

if (commentId && reply === false) {
    const commentElement = document.querySelector('#comments .comment-' + commentId)
    slideTo(commentElement)
}

/**
 * Keyup event handler for the title input field
 *
 * @deprecated The PHP code for this is commented out, so this is not needed anymore
 */
document.getElementById('title')?.addEventListener('keyup', function () {
    document.getElementById('title-transform').textContent = this.value
})

/**
 * Blog settings
 */
if (document.querySelector('.blog-form')) {
    blogSettings()
}
